import { render, staticRenderFns } from "./newCommodity.vue?vue&type=template&id=b2060fb6&scoped=true&"
import script from "./newCommodity.vue?vue&type=script&lang=js&"
export * from "./newCommodity.vue?vue&type=script&lang=js&"
import style0 from "./newCommodity.vue?vue&type=style&index=0&id=b2060fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2060fb6",
  null
  
)

export default component.exports